import { memo } from "react";
import { Card, Typography } from "antd";
import { StreamingText } from "./StreamingText";
import { MediaRender } from "./MediaRender";
import { AnimatedMediaRender } from "./AnimatedMediaRender";
import { ANIMATION } from "./animationConfig";
import { useImageSlideAnimation } from "./useSlideAnimation";
import type { SlideComponentProps } from "./SlideRenderer";
import { ImagePlaceholders } from "types/";

export const ImageSlide = memo(
  ({ slide, isActive = false, onComplete }: SlideComponentProps) => {
    const placeholders = slide.placeholders as ImagePlaceholders;
    const title = placeholders.title;
    const imageElement = placeholders.image_element;

    const { imageAsset, isLoading, imageUrl, nextStep, isStepActive } =
      useImageSlideAnimation(imageElement, 2, isActive, onComplete);

    // Not active yet - render static content
    if (!isActive) {
      return (
        <Card>
          <Typography.Title level={4}>{title}</Typography.Title>
          <MediaRender
            imageElement={imageElement}
            imageUrl={imageUrl}
            imageAsset={imageAsset}
            isLoading={isLoading}
          />
        </Card>
      );
    }

    return (
      <Card>
        {/* Step 0: Title */}
        {isStepActive(0) && (
          <Typography.Title level={4}>
            <StreamingText
              text={title}
              animate
              wordDelay={ANIMATION.WORD_DELAY}
              onComplete={nextStep}
            />
          </Typography.Title>
        )}

        {/* Step 1: Image */}
        {isStepActive(1) && (
          <AnimatedMediaRender
            imageElement={imageElement}
            imageUrl={imageUrl}
            imageAsset={imageAsset}
            isLoading={isLoading}
            onAnimationComplete={nextStep}
          />
        )}
      </Card>
    );
  }
);

ImageSlide.displayName = "ImageSlide";
